<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title mydocma-text-default">
      {{'MM.fault.import.title' | translate }}
    </div>
    <div>
      <button mat-icon-button type="button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <div class="fi-dialog-content" [@.disabled]="isAnimationUnsupportedDevice" [class.anim-off]="isAnimationUnsupportedDevice">
      <mydocma-loader class="mydocma-mm-loader" [size]="'middle'"
                      *ngIf="importStepperService.isLoading"></mydocma-loader>

      <mydocma-mm-faults-import-stepper #stepperComponent
        [@.disabled]="isAnimationUnsupportedDevice"
        [class.anim-off]="isAnimationUnsupportedDevice"

      >

      </mydocma-mm-faults-import-stepper>


    </div>
  </div>

  <div class="mydocma-dialog-footer">
    <mat-menu #menu="matMenu" class="fi-create-menu">
      <button class="fi-fab-button-item" mat-menu-item (click)="faultsImportService.downloadTemplate(fabButtonsEnum.templateByCode)">
        {{ lableCreateByStructureCode }}
      </button>
      <button class="fi-fab-button-item" mat-menu-item (click)="faultsImportService.downloadTemplate(fabButtonsEnum.templateByCodePath)">
        {{ lableCreateByStructurePath }}
      </button>
      <button class="fi-fab-button-item" mat-menu-item (click)="faultsImportService.downloadTemplate(fabButtonsEnum.templateByDescriptionPath)">
        {{ lableCreateByStructureDescription }}
      </button>
      <button class="fi-fab-button-item" mat-menu-item (click)="faultsImportService.downloadTemplate(fabButtonsEnum.templateByDisplayPath)">
        {{ lableCreateByStructureDisplayPath }}
      </button>
    </mat-menu>
    <button mat-stroked-button class="mydocma-btn-secondary" type="button" [matMenuTriggerFor]="menu" style="margin-right: 10px" >
      {{'MM.fault.import.create.button' | translate}}
    </button>

    <button mat-stroked-button type="submit" class="mydocma-btn" style="margin-right: 10px" (click)="onCancel()" >
      {{'MM.fault.import.buttonNext.cancel' | translate }}
    </button>
    <button mat-stroked-button type="button" class="mydocma-btn-primary" (click)="onNext()" [disabled]="!(importStepperService?.stepperService?.currStep?.completed ?? false) || this.faultsImportService.importStarted">
      {{ nextButtonText | translate }}
    </button>
  </div>
</div>
